import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { WorkflowCheckListItemResultDto } from './workflow-check-list-item-result-dto';
import { WorkflowCheckListRawDto } from './workflow-check-list-raw-dto';

export class WorkflowChecklistEditorResultDto {
    @Type(() => WorkflowCheckListItemResultDto)
    checklistItems: Array<WorkflowCheckListItemResultDto>;

    @Type(() => WorkflowCheckListRawDto)
    camChecklistStatuses: Array<WorkflowCheckListRawDto>;

    @Type(() => WorkflowCheckListRawDto)
    acctChecklistStatuses: Array<WorkflowCheckListRawDto>;

    @Type(() => KeyValueResultDto)
    statusOptions: Array<KeyValueResultDto>;
}
